import React from "react";
import styles from "../styles/AuthHeader.module.css";

const AvatarMenuItem = ({ onClick, menuItem, isActive, isMobile, showIcon, badge }) => {

	return (
		<div
			onClick={onClick}
			className={`${styles.avatarMenuOption} ${isMobile ? styles.mobile : ''} ${isActive ? styles.active : ''}`}
		>
			<div className="d-flex align-items-center gap-8">
				{showIcon ? (isActive ? (menuItem.activeIcon ?? menuItem.icon) : menuItem.icon) : null}

				{menuItem.labelComponent || <span className="tt-16 medium mb-0">{menuItem.label}</span>}

				{badge > 0 ? <span className={styles.menuBadge}>{badge}</span> : null}
			</div>
		</div>
	);
}

export default AvatarMenuItem;